import LocalizedStrings from "react-localization";
import { VNLocalizeStrings } from "./Vietnam";
export const strings = new LocalizedStrings({
    vietnam: VNLocalizeStrings
})